module.exports = __webpack_public_path__ + "static/media/eliza-jane-win.16fe0da0.jpg";